import { render, staticRenderFns } from "./DoneIssues.vue?vue&type=template&id=2007ecac&scoped=true&"
import script from "./DoneIssues.vue?vue&type=script&lang=ts&"
export * from "./DoneIssues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007ecac",
  null
  
)

export default component.exports